import Typography from '@/components/Typography';
import { TextStyles } from '@/constants';
import styled from 'styled-components';

/**
 * A logo sits straight on the card, with no backdrop — brand assets carry their own framing and a
 * grey box behind them reads as a broken image. Only the initial-letter fallback gets a filled tile,
 * because a lone letter needs a shape to read as a logo slot.
 */
export const TileWrapper = styled.div<{ $size: number; $radius: string; $filled?: boolean }>(
  ({ theme, $size, $radius, $filled }) => ({
    flex: `0 0 ${$size}px`,
    width: $size,
    height: $size,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    borderRadius: $radius,
    backgroundColor: $filled ? theme.colors.surface02 : 'transparent',
  }),
);

/**
 * `contain` rather than `cover`: brand logos arrive at whatever aspect ratio the carrier
 * publishes them at, and cropping one to fill a square would cut the wordmark in half.
 * Letterboxing inside the tile keeps every logo legible and the grid aligned.
 */
export const TileImage = styled.img({
  width: '100%',
  height: '100%',
  objectFit: 'contain',
});

export const TileInitial = styled(Typography).attrs({
  variant: TextStyles['Heading 1'],
  type: 'span',
})(({ theme }) => ({
  color: theme.colors.mediumEmphasisBlack,
  userSelect: 'none',
}));
